import { render, staticRenderFns } from "./isvps.vue?vue&type=template&id=7d1a2a65&scoped=true&"
import script from "./isvps.vue?vue&type=script&lang=js&"
export * from "./isvps.vue?vue&type=script&lang=js&"
import style0 from "./isvps.vue?vue&type=style&index=0&id=7d1a2a65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1a2a65",
  null
  
)

export default component.exports